// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/trading_contract_status.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/trading_contract_status.proto.
 */
export const file_bfftypes_v1_trading_contract_status: GenFile = /*@__PURE__*/
  fileDesc("CiliZmZ0eXBlcy92MS90cmFkaW5nX2NvbnRyYWN0X3N0YXR1cy5wcm90bxILYmZmdHlwZXMudjEq0wEKFVRyYWRpbmdDb250cmFjdFN0YXR1cxInCiNUUkFESU5HX0NPTlRSQUNUX1NUQVRVU19VTlNQRUNJRklFRBAAEiEKHVRSQURJTkdfQ09OVFJBQ1RfU1RBVFVTX0RSQUZUEAESIgoeVFJBRElOR19DT05UUkFDVF9TVEFUVVNfQUNUSVZFEAISIwofVFJBRElOR19DT05UUkFDVF9TVEFUVVNfRVhQSVJFRBADEiUKIVRSQURJTkdfQ09OVFJBQ1RfU1RBVFVTX0NBTkNFTExFRBAEQkJaQGdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnR5cGVzL3YxO2JmZnR5cGVzdjFiBnByb3RvMw");

/**
 * TradingContractStatus is the lifecycle state of a bilateral trade
 * contract. Mirrors backend types.v1.TradingContractStatus 1:1
 * (wire values are stable). Hosted under bfftypes/v1 for BFF-local reuse.
 *
 * @generated from enum bfftypes.v1.TradingContractStatus
 */
export enum TradingContractStatus {
  /**
   * @generated from enum value: TRADING_CONTRACT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * ドラフト (手入力契約のみ)。
   *
   * @generated from enum value: TRADING_CONTRACT_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * 成立済 (有効)。
   *
   * @generated from enum value: TRADING_CONTRACT_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * 期間満了 (受渡期間終了)。
   *
   * @generated from enum value: TRADING_CONTRACT_STATUS_EXPIRED = 3;
   */
  EXPIRED = 3,

  /**
   * キャンセル (取消)。
   *
   * @generated from enum value: TRADING_CONTRACT_STATUS_CANCELLED = 4;
   */
  CANCELLED = 4,
}

/**
 * Describes the enum bfftypes.v1.TradingContractStatus.
 */
export const TradingContractStatusSchema: GenEnum<TradingContractStatus> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_trading_contract_status, 0);

